import { Endpoint } from "@rest-hooks/endpoint";
export function isErrorFromBuyoutGetContract(res) {
    if (res == null || typeof res !== "object" || !("errors" in res)) {
        return false;
    }
    const errorResponse = res;
    return (Array.isArray(errorResponse?.errors) && errorResponse.errors.length > 0);
}
export function isSuccessFromBuyoutGetContract(res) {
    return !isErrorFromBuyoutGetContract(res);
}
const fetchBuyoutGetContract = async (values) => {
    const params = new URLSearchParams({
        registrationNumber: values.registrationNumber
    });
    const res = await fetch(`/buyout/GetContractByRegistrationNumber?${params.toString()}`, {
        method: "GET"
    });
    const data = await res.json();
    if (!res.ok || isErrorFromBuyoutGetContract(data)) {
        if (isErrorFromBuyoutGetContract(data)) {
            console.error("BuyoutGetContractError:", data.errors);
            return data;
        }
        const errorMessage = data.errors?.join(", ") || `HTTP ${res.status}: ${res.statusText}`;
        console.error("BuyoutGetContractError:", errorMessage);
        return {
            errors: [errorMessage]
        };
    }
    const contract = data;
    if (!isSuccessFromBuyoutGetContract(contract)) {
        console.error("Unexpected response format:", data);
        throw new Error("Unexpected response format");
    }
    return contract;
};
export const BuyoutGetContractEndpoint = new Endpoint(fetchBuyoutGetContract, {
    key({ registrationNumber }) {
        return `buyout-buyout-dates-${registrationNumber}`;
    },
    dataExpiryLength: 1000 * 60
});
//# sourceMappingURL=BuyoutGetContract.js.map